import React, { forwardRef } from 'react';

import { LocationInput, LocationInputProps } from 'components/common/LocationInput';

interface Props extends LocationInputProps {
  hidePoweredByGoogle?: boolean;
}

export const Location = forwardRef<HTMLInputElement, Props>(({ id, hidePoweredByGoogle, ...rest }, ref) => {
  return (
    <div>
      <LocationInput className='bg-white' id={id} ref={ref} placeholder='Location' {...rest} />
      {!hidePoweredByGoogle && (
        <img src='/temp-assets/powered_by_google.png' alt='powered_by_google_logo' className='pt-4' />
      )}
    </div>
  );
});
